module.exports = require('./feedforwardNeuralNetwork');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fnn/src/index.js
 ** module id = 145
 ** module chunks = 0
 **/